import React from 'react'

const NotiSettings = () => {
    return (
        <div className="_profile_details_main_content">
            <div className="_profile_details_main_content_txt">
                <h2 className="_profile_details_main_content_title text-center">
                    Notification Settings
                </h2>
                <p className="_profile_details_main_content_p text-center">
                    Select which notifications you would like to receive for 0x19d8...ee31
                </p>
            </div>
            <div className="_profile_details_main_content_input_wrap">
                <div className="row align-content-center my-3">
                    <div className="col-xl-9 col-lg-8 col-md-12 col-sm-12 mx-auto">
                        <div className="_profile_details_main_content_ul_wrap">
                            <div className="_profile_details_main_content_ul">
                                <div className="_profile_details_main_content_li">
                                    <div className="_profile_details_main_content_li_ic_wrap">
                                        <span className="_profile_details_main_content_li_ic">
                                            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24">
                                                <path fill="#292D32" d="M16.19 2H7.81C4.17 2 2 4.17 2 7.81v8.37C2 19.83 4.17 22 7.81 22h8.37c3.64 0 5.81-2.17 5.81-5.81V7.81C22 4.17 19.83 2 16.19 2Zm.59 7.7-5.67 5.67a.75.75 0 0 1-1.06 0l-2.83-2.83a.754.754 0 0 1 0-1.06c.29-.29.77-.29 1.06 0l2.3 2.3 5.14-5.14c.29-.29.77-.29 1.06 0 .29.29.29.76 0 1.06Z" />
                                            </svg>
                                        </span>
                                        <span className="_profile_details_main_content_li_txt">
                                            Item Sold
                                        </span>
                                    </div>
                                    <div className="_profile_details_main_content_li_txt_wrap">
                                        <p className="_profile_details_main_content_li_p">
                                            When someone purchased one of your items
                                        </p>
                                    </div>
                                </div>
                                <div className="_profile_details_main_content_li">
                                    <div className="_profile_details_main_content_li_ic_wrap">
                                        <span className="_profile_details_main_content_li_ic">
                                            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24">
                                                <path fill="#292D32" d="M16.19 2H7.81C4.17 2 2 4.17 2 7.81v8.37C2 19.83 4.17 22 7.81 22h8.37c3.64 0 5.81-2.17 5.81-5.81V7.81C22 4.17 19.83 2 16.19 2Zm.59 7.7-5.67 5.67a.75.75 0 0 1-1.06 0l-2.83-2.83a.754.754 0 0 1 0-1.06c.29-.29.77-.29 1.06 0l2.3 2.3 5.14-5.14c.29-.29.77-.29 1.06 0 .29.29.29.76 0 1.06Z" />
                                            </svg>
                                        </span>
                                        <span className="_profile_details_main_content_li_txt">
                                            Bid Activity
                                        </span>
                                    </div>
                                    <div className="_profile_details_main_content_li_txt_wrap">
                                        <p className="_profile_details_main_content_li_p">
                                            When someone bids on one of your items
                                        </p>
                                    </div>
                                </div>
                                <div className="_profile_details_main_content_li">
                                    <div className="_profile_details_main_content_li_ic_wrap">
                                        <span className="_profile_details_main_content_li_ic">
                                            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24">
                                                <path fill="#292D32" d="M16.19 2H7.81C4.17 2 2 4.17 2 7.81v8.37C2 19.83 4.17 22 7.81 22h8.37c3.64 0 5.81-2.17 5.81-5.81V7.81C22 4.17 19.83 2 16.19 2Zm.59 7.7-5.67 5.67a.75.75 0 0 1-1.06 0l-2.83-2.83a.754.754 0 0 1 0-1.06c.29-.29.77-.29 1.06 0l2.3 2.3 5.14-5.14c.29-.29.77-.29 1.06 0 .29.29.29.76 0 1.06Z" />
                                            </svg>
                                        </span>
                                        <span className="_profile_details_main_content_li_txt">
                                            Price Change
                                        </span>
                                    </div>
                                    <div className="_profile_details_main_content_li_txt_wrap">
                                        <p className="_profile_details_main_content_li_p">
                                            When an item you made an offer on changes in price
                                        </p>
                                    </div>
                                </div>
                                <div className="_profile_details_main_content_li">
                                    <div className="_profile_details_main_content_li_ic_wrap">
                                        <span className="_profile_details_main_content_li_ic">
                                            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24">
                                                <path fill="#292D32" d="M16.19 2H7.81C4.17 2 2 4.17 2 7.81v8.37C2 19.83 4.17 22 7.81 22h8.37c3.64 0 5.81-2.17 5.81-5.81V7.81C22 4.17 19.83 2 16.19 2Zm.59 7.7-5.67 5.67a.75.75 0 0 1-1.06 0l-2.83-2.83a.754.754 0 0 1 0-1.06c.29-.29.77-.29 1.06 0l2.3 2.3 5.14-5.14c.29-.29.77-.29 1.06 0 .29.29.29.76 0 1.06Z" />
                                            </svg>
                                        </span>
                                        <span className="_profile_details_main_content_li_txt">
                                            Auction Expiration
                                        </span>
                                    </div>
                                    <div className="_profile_details_main_content_li_txt_wrap">
                                        <p className="_profile_details_main_content_li_p">
                                            When a timed auction you created ends
                                        </p>
                                    </div>
                                </div>
                                <div className="_profile_details_main_content_li">
                                    <div className="_profile_details_main_content_li_ic_wrap">
                                        <span className="_profile_details_main_content_li_ic">
                                            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24">
                                                <path fill="#292D32" d="M16.19 2H7.81C4.17 2 2 4.17 2 7.81v8.37C2 19.83 4.17 22 7.81 22h8.37c3.64 0 5.81-2.17 5.81-5.81V7.81C22 4.17 19.83 2 16.19 2Zm.59 7.7-5.67 5.67a.75.75 0 0 1-1.06 0l-2.83-2.83a.754.754 0 0 1 0-1.06c.29-.29.77-.29 1.06 0l2.3 2.3 5.14-5.14c.29-.29.77-.29 1.06 0 .29.29.29.76 0 1.06Z" />
                                            </svg>
                                        </span>
                                        <span className="_profile_details_main_content_li_txt">
                                            Outbid
                                        </span>
                                    </div>
                                    <div className="_profile_details_main_content_li_txt_wrap">
                                        <p className="_profile_details_main_content_li_p">
                                            When an offer you placed is exceeded by another user
                                        </p>
                                    </div>
                                </div>
                                <div className="_profile_details_main_content_li">
                                    <div className="_profile_details_main_content_li_ic_wrap">
                                        <span className="_profile_details_main_content_li_ic">
                                            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24">
                                                <path fill="#292D32" d="M16.19 2H7.81C4.17 2 2 4.17 2 7.81v8.37C2 19.83 4.17 22 7.81 22h8.37c3.64 0 5.81-2.17 5.81-5.81V7.81C22 4.17 19.83 2 16.19 2Zm.59 7.7-5.67 5.67a.75.75 0 0 1-1.06 0l-2.83-2.83a.754.754 0 0 1 0-1.06c.29-.29.77-.29 1.06 0l2.3 2.3 5.14-5.14c.29-.29.77-.29 1.06 0 .29.29.29.76 0 1.06Z" />
                                            </svg>
                                        </span>
                                        <span className="_profile_details_main_content_li_txt">
                                            Owned Item Updates
                                        </span>
                                    </div>
                                    <div className="_profile_details_main_content_li_txt_wrap">
                                        <p className="_profile_details_main_content_li_p">
                                            When a significant update occurs for one of the items
                                            you have purchased on OpenSea
                                        </p>
                                    </div>
                                </div>
                                <div className="_profile_details_main_content_li">
                                    <div className="_profile_details_main_content_li_ic_wrap">
                                        <span className="_profile_details_main_content_li_ic">
                                            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24">
                                                <path fill="#292D32" d="M16.19 2H7.81C4.17 2 2 4.17 2 7.81v8.37C2 19.83 4.17 22 7.81 22h8.37c3.64 0 5.81-2.17 5.81-5.81V7.81C22 4.17 19.83 2 16.19 2Zm.59 7.7-5.67 5.67a.75.75 0 0 1-1.06 0l-2.83-2.83a.754.754 0 0 1 0-1.06c.29-.29.77-.29 1.06 0l2.3 2.3 5.14-5.14c.29-.29.77-.29 1.06 0 .29.29.29.76 0 1.06Z" />
                                            </svg>
                                        </span>
                                        <span className="_profile_details_main_content_li_txt">
                                            Successful Purchase
                                        </span>
                                    </div>
                                    <div className="_profile_details_main_content_li_txt_wrap">
                                        <p className="_profile_details_main_content_li_p">
                                            When you successfully buy an item
                                        </p>
                                    </div>
                                </div>
                                <div className="_profile_details_main_content_li">
                                    <div className="_profile_details_main_content_li_ic_wrap">
                                        <span className="_profile_details_main_content_li_ic">
                                            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24">
                                                <path fill="#292D32" d="M16.19 2H7.81C4.17 2 2 4.17 2 7.81v8.37C2 19.83 4.17 22 7.81 22h8.37c3.64 0 5.81-2.17 5.81-5.81V7.81C22 4.17 19.83 2 16.19 2Zm.59 7.7-5.67 5.67a.75.75 0 0 1-1.06 0l-2.83-2.83a.754.754 0 0 1 0-1.06c.29-.29.77-.29 1.06 0l2.3 2.3 5.14-5.14c.29-.29.77-.29 1.06 0 .29.29.29.76 0 1.06Z" />
                                            </svg>
                                        </span>
                                        <span className="_profile_details_main_content_li_txt">
                                            OpenSea Newsletter
                                        </span>
                                    </div>
                                    <div className="_profile_details_main_content_li_txt_wrap">
                                        <p className="_profile_details_main_content_li_p">
                                            Occasional updates from the OpenSea team
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="_profile_details_main_content_bottom">
                            <div className="_profile_details_main_content_bottom_txt">
                                <h3 className="_profile_details_main_content_bottom_title">
                                    Minimum Bid Threshold
                                </h3>
                                <p className="_profile_details_main_content_bottom_p">
                                    Receive notifications only when you receive offers with a value greater than
                                    or equal to this amount of ETH.
                                </p>

                            </div>
                        </div>
                        <div className="row">
                            <div className="col-xl-12 col-lg-12 col-md-12 col-sm-12">
                                <div className="_profile_details_main_noti_input_wrap">
                                    <button className="_profile_details_main_noti_input_btn">
                                        <span className="_profile_details_main_noti_input_btn_ic">
                                            <svg xmlns="http://www.w3.org/2000/svg" width="15" height="24" fill="none" viewBox="0 0 15 24">
                                                <path fill="#fff" d="M7.5 0 0 12.293l7.5 4.39 7.5-4.39L7.5 0ZM0 13.756 7.5 24 15 13.756l-7.5 4.39-7.5-4.39Z" />
                                            </svg>
                                        </span>
                                        <span className="_profile_details_main_noti_input_btn_txt">
                                            ETH
                                        </span>
                                    </button>
                                    <input type="text" className='_profile_details_main_input' placeholder='0.005'/>
                                </div>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-xl-12 col-lg-12 col-md-12 col-sm-12">
                                <div className="_profile_details_main_input_wrap">
                                    <button className="_profile_details_main_input_btn">
                                        <span className="_profile_details_main_input_btn_txt">
                                            Save
                                        </span>
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default NotiSettings